module.exports = {
      id: "audio-play-usage",
      viewBox: "0 0 384 512",
      url: "/" + "sprite-326d1762f7ed1f924194ae9c5468ee69.svg#audio-play",
      toString: function () {
        return this.url;
      }
    }